import React from "react";
import ConnectStore from "../ConnectStore";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { ConnectStoreIcon } from "../../../../../assets/svgIcons";

const EditConnectionLayout = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.3 } }}
      className={`${globalStyles?.pagePaddings} ${globalStyles.pageColumnGaps}`}
    >
      <div>
        <h4 className="mb-2">Update This Connection</h4>
        <div style={{ gap: 8 }} className="d-flex">
          <p>Chowdeck Store A</p>
          <ConnectStoreIcon />
          <p>Lumi Business Store A</p>
        </div>
      </div>
      <div>
        <ConnectStore />
      </div>
    </motion.div>
  );
};

export default EditConnectionLayout;
